module.exports = __webpack_public_path__ + "img/success-case-1.af44f6f1.png";